import { NgModule } from 'ng-metadata/core';
import {PrmIcon} from './icon.directive';

@NgModule({
    declarations: [PrmIcon],
    providers: []
})
export class IconModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/icon/icon.module.ts